module.exports = __webpack_public_path__ + "static/artist-development-hero-550732e5bbbe042138939ec25ad0eac3.png";